import { Authority, getP44Env } from '@project44/ui-utils';

import { IGuard } from '../types';
import {
  ANALYTICS_AUTHORITIES,
  INITIATE_AUTHORITIES,
  P44OS_AUTHORIITES,
} from './authorityGroupings';

export const analyticsAccessCheckDeprecated = ({ user }: IGuard): boolean => {
  return !!user?.authorities.some((y) =>
    ANALYTICS_AUTHORITIES.includes(y?.authority),
  );
};

export const analyticsAccessCheck = ({ user, flags }: IGuard): boolean => {
  const { analyticsNavAmi1298 } = flags ?? {};
  return (
    analyticsNavAmi1298 &&
    !!user?.authorities.some((y) =>
      ANALYTICS_AUTHORITIES.includes(y?.authority),
    )
  );
};

export const dashboardAccessCheck = ({ flags }: IGuard): boolean => {
  return !!flags?.featureExc2061;
};

export const initiateAccessCheck = ({ user, flags }: IGuard): boolean => {
  if (flags && flags['hideInEu'] && getP44Env().ENV === 'production-eu') {
    return false;
  }
  return !!user?.authorities.some((y) =>
    INITIATE_AUTHORITIES.includes(y?.authority),
  );
};

export const initiateMarketingSectionAccessCheck = ({
  user,
  flags,
}: IGuard): boolean => {
  if (flags && flags['hideInEu'] && getP44Env().ENV === 'production-eu') {
    return false;
  }
  return !initiateAccessCheck({ user });
};

// The following are individual analytics authority checks
export const analyticsLtlAccessCheck = ({ user, flags }: IGuard): boolean => {
  const { ltlAnalyticsRelease1Ami1307 } = flags ?? {};
  return (
    ltlAnalyticsRelease1Ami1307 &&
    !!user?.authorities.some((y) =>
      [Authority.ANALYTICS_LTL].includes(y?.authority),
    )
  );
};

export const analyticsOceanAccessCheck = ({ user, flags }: IGuard): boolean => {
  const { analyticsNavAmi1298 } = flags ?? {};
  return (
    analyticsNavAmi1298 &&
    !!user?.authorities.some((y) =>
      [Authority.ANALYTICS_OCEAN].includes(y?.authority),
    )
  );
};

export const analyticsPortIntelAccessCheck = ({
  user,
  flags,
}: IGuard): boolean => {
  const { analyticsNavAmi1298 } = flags ?? {};
  return (
    analyticsNavAmi1298 &&
    !!user?.authorities.some((y) =>
      [Authority.ANALYTICS_PORT_INTEL].includes(y?.authority),
    )
  );
};

export const analyticsSustainabilityAccessCheck = ({
  user,
  flags,
}: IGuard): boolean => {
  const { analyticsNavAmi1298 } = flags ?? {};
  return (
    analyticsNavAmi1298 &&
    !!user?.authorities.some((y) =>
      [Authority.ANALYTICS_OCEAN_SUSTAINABILITY].includes(y?.authority),
    )
  );
};

export const analyticsTruckloadAccessCheck = ({
  user,
  flags,
}: IGuard): boolean => {
  const { analyticsNavAmi1298 } = flags ?? {};
  return (
    analyticsNavAmi1298 &&
    !!user?.authorities.some((y) =>
      [Authority.ANALYTICS_TRUCKLOAD].includes(y?.authority),
    )
  );
};

export const analyticsTruckloadTrackingRcaAccessCheck = ({
  user,
  flags,
}: IGuard): boolean => {
  const { networkNavConsumption } = flags ?? {};
  return (
    !networkNavConsumption &&
    (user?.tenantCarrierNetworkRoles.includes('SHIPPER') as boolean) &&
    !!user?.authorities.some((y) =>
      [Authority.ANALTYICS_ROOT_CAUSE_ANALYSIS].includes(y?.authority),
    )
  );
};

export const networkTruckloadTrackingRcaAccessCheck = ({
  user,
  flags,
}: IGuard): boolean => {
  const { networkNavConsumption, tlrcaCarriers } = flags ?? {};

  return (
    networkNavConsumption &&
    ((user?.tenantCarrierNetworkRoles.includes('SHIPPER') as boolean) ||
      tlrcaCarriers) &&
    !!user?.authorities.some((y) =>
      [Authority.ANALTYICS_ROOT_CAUSE_ANALYSIS].includes(y?.authority),
    )
  );
};

export const networkLinkCheck = ({ user, flags }: IGuard): boolean => {
  const { featureRtcn806 } = flags ?? {};
  return (
    ((user?.tenantCarrierNetworkRoles.includes('SHIPPER') as boolean) ||
      ((user?.tenantCarrierNetworkRoles.includes('CARRIER') as boolean) &&
        featureRtcn806)) &&
    !!user?.authorities.some((y) =>
      [Authority.NETWORK_READ_HEALTH_DASHBOARD].includes(y?.authority),
    )
  );
};

export const networkParentLink = ({ user, flags }: IGuard): boolean => {
  const { networkNavConsumption, tlrcaCarriers } = flags ?? {};

  return (
    networkNavConsumption &&
    ((user?.tenantCarrierNetworkRoles.includes('SHIPPER') as boolean) ||
      tlrcaCarriers) &&
    !!user?.authorities.some((y) =>
      [
        Authority.NETWORK_READ_HEALTH_DASHBOARD,
        Authority.ANALTYICS_ROOT_CAUSE_ANALYSIS,
      ].includes(y?.authority),
    )
  );
};

export const p44osAccessCheck = ({ user }: IGuard): boolean => {
  return !!user?.authorities.some((y) =>
    P44OS_AUTHORIITES.includes(y?.authority),
  );
};

export const networkDirectoryCheck = ({ user, flags }: IGuard): boolean =>
  (flags?.featureNx779 &&
    user?.tenantCarrierNetworkRoles.includes('SHIPPER') &&
    user?.authorities.some((y) =>
      [Authority.NETWORK_READ_DIRECTORY_CARRIERS].includes(y?.authority),
    )) as boolean;
